import React from 'react';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
} from '@material-ui/core';
import { ChromePicker } from 'react-color';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  customWidth: {
    width: '265px',
    zIndex: '2'
  },
  fixedBackdrop: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px'
  },
  zIndex2: {
    zIndex: '2'
  }
});

const BorderPickerDialog = ({value, toggleShowPicker, onChange}) => {
  const classes = useStyles();
  const borderValues = value.split(' ');
  const [borderWidth, setBorderWidth] = React.useState(borderValues[0].replace('px', ''));
  const [borderStyle, setBorderStyle] = React.useState(borderValues[1]);
  const [borderColor, setBorderColor] = React.useState(borderValues[2]);


  return (
    <div className={`relative ${classes.customWidth} ${classes.zIndex2}`}>
      <div
        className={classes.fixedBackdrop}
        onClick={() => toggleShowPicker(false)}
      />
      <div className={`bg-white elevation-z5 p-5 absolute w-full ${classes.zIndex2}`}>
        <div className="pt-8">
          <Slider
            value={borderWidth}
            step={1}
            max={5}
            valueLabelDisplay="on"
            onChange={(_, value) => {
              setBorderWidth(`${value}`);
              onChange(`${value}px ${borderStyle} ${borderColor}`);
            }}
          />
        </div>
        <div>
          <RadioGroup
            name="borderStyle"
            value={borderStyle}
            onChange={(event) => {
              setBorderStyle(`${event.target.value}`);
              onChange(`${borderWidth}px ${event.target.value} ${borderColor}`);
            }}
          >
            <div className="flex items-center flex-wrap">
              <FormControlLabel
                className="max-w-100 w-full text-left"
                value="solid"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={(e) => e.preventDefault()}
                  />}
                label="solid"
              />
              <FormControlLabel
                className="max-w-100 w-full text-left"
                value="double"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />}
                label="double"
              />
              <FormControlLabel
                className="max-w-100 w-full text-left"
                value="inset"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />}
                label="inset"
              />
              <FormControlLabel
                className="max-w-100 w-full text-left"
                value="groove"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />}
                label="groove"
              />
            </div>
          </RadioGroup>
        </div>
        <ChromePicker
          className="my-2"
          color={borderColor}
          onChange={(color) => {
            setBorderColor(`${color.hex}`);
            onChange(`${borderWidth}px ${borderStyle} ${color.hex}`);
          }}
        />
      </div>
    </div>);
};

export default BorderPickerDialog;
